import styles from './Decision.module.css';
import deferredIcon from '../../assets/deferred.svg';

const DeferredDecision = () => {
  return (
    <div className={styles.container}>
      <div className={styles.gifContainer}>
        <img data-testid="deferred-icon" src={deferredIcon} alt="" />
      </div>
      <h1 className={styles.heading}>Your application is on hold</h1>
      <p className={styles.declineInfo}>
        If you’d like to speak to us, or if you have any questions, give us a
        ring on{' '}
        <a href="tel:02037780105" target="_blank" rel="noreferrer">
          020 3778 0105
        </a>
      </p>
    </div>
  );
};

export default DeferredDecision;
